<div class="wrap">
  <div class="title">
    <h3>{{title}}</h3>

    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher un achat ..."
          (input)="applyFilter($event.target.value)" formControlName="keyword">
      </form>

      <fa-icon [icon]=" valueInput? getFaIcon('faTimes'): getFaIcon('faSearch')" (click)="valueInput ? resetSearch(): ''"></fa-icon>
    </div>
  </div>

   <div class="book_mobil_tablet">
    <form [formGroup]="selectBookingMobileForm">
      <mat-form-field appearance="outline">
        <mat-label>
          <fa-icon [icon]="getFaIcon('faShoppingBasket')"></fa-icon>
          Mes réservations
        </mat-label>
        <mat-select [panelClass]="'panel-override'" formControlName="selectBooking"
        (selectionChange)="getSession($event, true)">
          <mat-option *ngIf="valueInput && !bookingFiltered?.length" value="no_result">
            Il n'y a pas de résultat
          </mat-option>
           <mat-option
              *ngFor="let b of bookingFiltered?.length ? bookingFiltered : booking"
              [value]="b">
              {{b.bookingReference}} - {{b.bookingRecordDate | date: 'shortDate':'UTC'}} (<strong>{{b.bookingAmount}}€</strong>)
            </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <form [formGroup]="selectSessionForm" *ngIf="sessions.length && (valueInput && bookingFiltered?.length || booking && !valueInput)">
      <mat-form-field appearance="outline">
        <mat-label>
          <fa-icon [icon]="getFaIcon('faCalendarAlt')"></fa-icon>
          Mes sessions
        </mat-label>
        <mat-select [panelClass]="'panel-override'" formControlName="session">
          <mat-option *ngIf="!sessions?.length" value="no_result">
            Aucune session
          </mat-option>
           <mat-option
              *ngFor="let s of sessions"
              [value]="s">
              {{s.sessionName}} - {{s.sessionStartDate | date: 'shortDate':'UTC'}} - <strong>{{s.bookedSessionAmount}}€</strong>
            </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="sessions_list" *ngIf="valueInput && bookingFiltered?.length || booking && !valueInput">
      <div class="session_list_header">
        <div class="tab_selected"  style="--tagSelected: {{getMargin()}}"  >

        </div>
        <div class="text_center" (click)="setTab('overview')">Offre</div>
        <div class="text_center" (click)="setTab('trainee')">Stagiaires</div>
        <div class="text_center" (click)="setTab('club')">Club</div>
      </div>

      <div class="session_list_content">
        <div [ngSwitch]="tab">

          <ng-container *ngSwitchCase="'overview'" >
            <app-session-booked-overview-session *ngIf="selectSession.session?.value?.offer"  [session]="selectSession.session?.value?.offer"></app-session-booked-overview-session>
            <p class="no_overview" *ngIf="!selectSession.session?.value?.offer">Aucun apreçu disponible</p>
          </ng-container>

          <app-session-booked-overview-trainee *ngSwitchCase="'trainee'" [trainees]="selectSession.session?.value.trainees"></app-session-booked-overview-trainee>
          <app-session-booked-overview-club *ngSwitchCase="'club'" [club]="selectSession.session?.value.club"></app-session-booked-overview-club>
        </div>
      </div>

    </div>

    <hr>

  </div>

  <div class="book_desktop">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="pdf">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> </th>
        <td mat-cell *matCellDef="let element" class="cell_action" (click)=" $event.preventDefault(); $event.stopPropagation()">
        <fa-icon *ngIf="!element.isDownloading" [icon]="getFaIcon('faFilePdf')"  [matTooltip]="getTooltip('downloadBill')"(click)="exportPdfBill(element);" appChangeColorTheme attribute="color"></fa-icon>
        <mat-spinner class="spinnerDownloading" *ngIf="element.isDownloading" [diameter]="20"></mat-spinner>
        </td>
      </ng-container>

      <ng-container matColumnDef="bookingReference">
        <th mat-header-cell *matHeaderCellDef > N° de facture
        </th>
        <td mat-cell *matCellDef="let element" > {{element.bookingReference}}  </td>
      </ng-container>

      <ng-container matColumnDef="bookingRecordDate">
        <th mat-header-cell *matHeaderCellDef > Date d'achat</th>
        <td mat-cell *matCellDef="let element" >  {{element.bookingRecordDate | date: 'short':'UTC'}}  </td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef > Nom </th>
        <td mat-cell *matCellDef="let element" > {{element.lastName}}  </td>
      </ng-container>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef > Prénom</th>
        <td mat-cell *matCellDef="let element" > {{element.firstName}}  </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef > Email</th>
        <td mat-cell *matCellDef="let element" > {{element.email}}  </td>
      </ng-container>

      <ng-container matColumnDef="bookedSessionCount">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Nbr d'offre(s)</th>
        <td mat-cell *matCellDef="let element" class="cell_action">  {{element.bookedSessionCount}} </td>
      </ng-container>

      <ng-container matColumnDef="bookingAmount">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Prix</th>
        <td mat-cell *matCellDef="let element" class="cell_action">  {{element.bookingAmount}}€ </td>
      </ng-container>



      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <app-sessions-infos [bookingKey]="expandedElement === element? element.bookingKey : null" ></app-sessions-infos>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        [style.opacity]=" !expandedElement || expandedElement === element  ? 1: .5"
        (click)="updateExpandedElement(element)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    <div class="no_result" *ngIf="!dataSource?.data?.length || !dataSource?.filteredData?.length">
      <p>Il n'y a pas de résultat</p>
    </div>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
      [color]="color">
    </mat-paginator>



  </div>

</div>
